import React from "react";
import { graphql } from "gatsby";
// import {
//   LinkButton,
//   LinkButtonProps,
// } from "@zempler/theme/src/components/buttons/linkButton/LinkButton";

interface ButtonBarCalculatorDataProps {
  data: LinkButtonProps;
  [key: string]: any;
}

export const ButtonBarCalculator: React.FC<ButtonBarCalculatorDataProps> = ({ data }) => {
  return (
    <>
    TODO - Calculator!
    </>
  );
};

export const ButtonBarCalculatorQuery = graphql`
  fragment ButtonBarCalculator on UMBRACO_ButtonBarCalculatorComponentType {
    style
    icon
    backgroundColour
    heading
  }
`;
